import { render } from "./BasePagination.vue?vue&type=template&id=86a14c38"
import script from "./BasePagination.vue?vue&type=script&lang=js"
export * from "./BasePagination.vue?vue&type=script&lang=js"

import "./BasePagination.vue?vue&type=style&index=0&id=86a14c38&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__